import React from "react";

/* Filled circle with a check — checklist bullets. */
export const CheckCircleIcon = ({
  size = 14,
  stroke = "var(--owner-check)",
  fill = "rgba(255,140,110,.22)",
  className = "shrink-0 mt-0.5",
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="7" cy="7" r="6.3" fill={fill} />
    <path
      d="M3.6 7.2L5.9 9.5L10.5 4.5"
      stroke={stroke}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export default CheckCircleIcon;
